import axios from "axios";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

const Steps4 = ({
  count,
  setCount,
  detailsSet,
  details,
  initialData,
  completeCurrentStep,
}) => {
  const [currentStatus, setCurrentStatus] = useState("");
  const [formData, setFormData] = useState();
  const [errors, setErrors] = useState();
  var userMemberId = localStorage.getItem("aimsUserMemberId");

  useEffect(() => {
    setFormData(details);
  }, [details]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value = "" } = e.target;
    if (!!name) {
      setFormData({ ...formData, [name]: value });
    }
  };

  const transformData = (data) => {
    const education_occupation = {
      basic_education: data.basiceducation || "",
      professional_education: data.professionaleducational || "",
      specialization: data.specialization || "",
      current_status: data.curerntstatus || "",
      be_stream: data.be_stream || "",
      be_subject: data.be_subject || "",
    };

    if (data.curerntstatus !== "Student") {
      education_occupation.occupation = data.occupation || "";
    } else {
      education_occupation.occupation = ""; // Ensure occupation is empty if Student
    }

    return {
      education_occupation: education_occupation,
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formattedData = transformData(formData);
    detailsSet(formData)
    sendEducationDetails(formattedData);
  };

  const sendEducationDetails = (el) => {
    axios
      .post(
        `https://anoopam.com/aims/api/?action=educationdetails&memberid=${userMemberId}`,
        { ...el }
      )
      .then((res) => {
        // console.log(res?.data);
        if (res?.data?.status === "success") {
          Swal.fire({
            text: `${res?.data?.msg}`,
            icon: "success",
          });
          setCount(count + 1);
        } else {
          Swal.fire({
            text: `${res?.data?.message}`,
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: `${err?.data?.message}`,
          icon: "error",
        });
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mt-4 main p-4 border rounded-4  bg-white">
        <div className="row ">
          <div className="col-lg-2">
            <label className="tittle-text" htmlFor="education">
              Basic Education
            </label>
            <select
              name="basiceducation"
              value={formData?.basiceducation || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option value="">Select Title</option>
              {initialData?.basiceducation?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
          </div>

          <div className="col-lg-5">
            <label className="tittle-text" htmlFor="Professional Education">
              {" "}
              Professional Education
            </label>
            <select
              name="professionaleducational"
              value={formData?.professionaleducational || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option value="">Select Title</option>
              {initialData?.profeducation?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
          </div>
          <div className="col-lg-5">
            <label className="tittle-text" htmlFor="name">
              Specialization
            </label>
            <select
              name="specialization"
              value={formData?.specialization || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              {" "}
              <option value="">Select Title</option>
              {initialData?.specialisation?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
          </div>

          <div className="col-lg-5">
            <label className="tittle-text" htmlFor="be_stream">
              {" "}
              Be Stream
            </label>
            <input
              name="be_stream"
              value={formData?.be_stream || ""}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter Be Stream"
              className="form-control mt-2 "
            />
          </div>

          <div className="col-lg-5">
            <label className="tittle-text" htmlFor="be_subject">
              {" "}
              Be Subject
            </label>
            <input
              name="be_subject"
              value={formData?.be_subject || ""}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter Be Subject"
              className="form-control mt-2 "
            />
          </div>

          {/* current Status  */}

          <div className="col-11 mt-3">
            <label className="form-label tittle-text fw-semibold">
              Current Status
            </label>
            <div className="d-flex gap-3 flex-wrap">
              {["Student", "Service", "Business", "Retired", "Honorary"].map(
                (status, index) => (
                  <React.Fragment key={index}>
                    <input
                      hidden
                      type="radio"
                      name="curerntstatus"
                      value={status}
                      id={`curerntstatus-${index}`}
                      onChange={handleInputChange}
                      key={index}
                    />
                    <label
                      htmlFor={`curerntstatus-${index}`}
                      className={`btn rounded-5 button1 ${
                        formData?.curerntstatus === status ? "active" : ""
                      }`}
                    >
                      {status}
                    </label>
                  </React.Fragment>
                )
              )}
            </div>
          </div>
          {formData?.curerntstatus && formData?.curerntstatus !== "Student" && (
            <div className="col-11 mt-3">
              <div className="col-lg-2 col-md-6 ">
                <label className="tittle-text" htmlFor="occupation">
                  Occupation
                </label>
                <select
                  name="occupation"
                  className="form-select mt-2"
                  aria-label="Default select example"
                  value={formData?.occupation || ""}
                  onChange={handleInputChange}
                >
                  <option className="inputText" value="">
                    Select...
                  </option>
                  {initialData?.occupation?.map((title, index) => (
                    <option key={index} value={title?.list_value}>
                      {title?.list_label}
                    </option>
                  )) || <option>Loading...</option>}
                </select>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="d-flex justify-content-end gap-3 mt-3">
        {count !== 0 && (
          <button
            className="rounded-5 btnBlue"
            onClick={() => setCount(count - 1)}
          >
            Previous
          </button>
        )}
        {count < 5 && (
          <button type="submit" className="rounded-5 btnBlue">
            Next
          </button>
        )}
      </div>
    </form>
  );
};

export default Steps4;
